import React from "react";
import { Link } from "react-router-dom";

const cols = [
  { title: "Company", links: [["About", "/#why"], ["Research", "/#brand-story"], ["Journal", "/#journal"], ["Contact", "/#contact"]] },
  { title: "Research", links: [["All Products", "/products"], ["Collections", "/#collections"], ["COAs", "/#process"]] },
  { title: "Programs", links: [["Partnership Program", "/partners"], ["Rewards", "/account?tab=rewards"], ["Peptide Quiz", "/quiz"], ["Compare Peptides", "/compare"]] },
  { title: "Support", links: [["Shipping", "/shipping"], ["FAQ", "/faq"], ["Contact", "/#contact"], ["Account", "/account"]] },
  { title: "Policies", links: [["Privacy", "/privacy"], ["Terms", "/terms"], ["Disclaimer", "/disclaimer"]] },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0F0F10] border-t border-white/10">
      <div className="mx-auto max-w-[1500px] px-6 sm:px-10 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
          <div className="lg:col-span-4">
            <Link to="/" className="font-display font-semibold text-2xl tracking-tight text-[#F5F5F5]">
              Enda<span className="text-[#4ADE80]">G1</span>
            </Link>
            <p className="mt-6 text-[15px] text-[#A8A8A8] font-light max-w-sm leading-relaxed">
              Research peptides manufactured to exacting standards, independently verified, and trusted by laboratories committed to scientific excellence.
            </p>
            <p className="mt-8 text-[11px] uppercase tracking-[0.18em] text-[#A8A8A8]">Visa · Mastercard · Amex · PayPal · Interac · SSL Secure</p>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-10">
            {cols.map((c) => (
              <div key={c.title} data-testid={`footer-col-${c.title.toLowerCase()}`}>
                <p className="text-[11px] uppercase tracking-[0.2em] text-[#4ADE80] mb-5">{c.title}</p>
                <ul className="space-y-3.5 text-[14px] font-light">
                  {c.links.map(([label, to]) => (
                    <li key={label}>
                      <Link
                        data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                        className="text-[#A8A8A8] hover:text-[#F5F5F5] transition-colors"
                        to={to}
                      >
                        {label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 border-t border-white/10 pt-8">
          <p className="text-[12px] leading-relaxed text-[#7a7a7a] max-w-3xl font-light">
            <span className="text-[#A8A8A8]">Research Use Only.</span> Not for human or veterinary use. Products are intended exclusively for laboratory and scientific research by qualified professionals. Statements on this website have not been evaluated by Health Canada or the U.S. Food and Drug Administration.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row justify-between gap-3 text-[11px] uppercase tracking-[0.18em] text-[#7a7a7a]">
            <span>© {new Date().getFullYear()} EndaG1 Research</span>
            <span>Precision is everything.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
